import React from 'react'
import '../../animation/anima.css'
import Button from '../Button'
import { Link } from 'react-router-dom'


const Servicebanner = () => {
  return (
      <div className='animate-fade-in-down  my-20 pb-20'>
          <div className=" text-prime flex items-center justify-center font-semibold text-2xl font-[Montserrat] mt-40">
            Software Development Services
          </div>
      <div className="flex items-center justify-center text-6xl font-[Montserrat] font-bold mt-20">
        Creating Succesful
      </div>
      <div className="flex items-center justify-center text-6xl font-[Montserrat] font-bold mt-10">
        Software Solutions
      </div>
      <div className="flex items-center justify-center text-3xl font-[Montserrat] font-medium mt-16">
        From vision to the final product — we’ll be there at every step.Experience a
      </div>
      <div className="flex items-center justify-center text-3xl font-[Montserrat] font-medium mt-2">
        smooth software development life cycle with our services.
      </div>
      <div className="mt-10 flex items-center justify-center">
            <Button className=''>
             <Link to='/contact'className='flex item-center justify-center' >Contact Us <ion-icon name="arrow-forward-outline" style={{marginTop: '5px', marginLeft: '5px'}}></ion-icon></Link>      
          </Button>
      </div>
    </div>
  )
}

export default Servicebanner
